// PlannerHeaderDay Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

class PlannerHeaderDay extends Component {
  static get propTypes () {
    return {
      active: PropTypes.string,
      items: PropTypes.array
    }
  }

  static get defaultProps () {
    const currDate = new Date()

    return {
      active: `${currDate.getDate()}-${currDate.getMonth() +
        1}-${currDate.getFullYear()}`,
      items: []
    }
  }

  render () {
    const { items } = this.props

    return (
      <div className='planner-headerday'>
        <div className='items'>
          {items.map(item => (
            <div
              key={new Date(item.date).toString()}
              className={classnames('item', {
                active: item.isToday,
                disabled: item.isWeekEnd
              })}
            >
              <span className='title'>{item.title}</span>
              <span className='dayno'>{item.dayNo}</span>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default PlannerHeaderDay
